export class addthisToolbox {
  constructor($window) {
    return {
            restrict: 'A',
            transclude: true,
            replace: true,
            template: '<div ng-transclude></div>',
            link: function ($scope, element, attrs) {
                var at = window.addthis;
                if (!at) return;
                if (at.layers.refresh) {
                  at.layers.refresh();
                } else {
                  at.init();
                  at.toolbox($(element).get());
                }
            }
        };
    }
  }
